'use strict';

// export this package's api
module.exports = require('./Pagination');


//////////////////
// WEBPACK FOOTER
// ./~/.1.8.2@rc-pagination/lib/index.js
// module id = 291
// module chunks = 0